export const projects = [
  {
    slug: "nord-79",
    title: "NORD/79",
    type: "Научная экспедиция",
    note: "Документальный сторителлинг и данные",
    image: "/assets/nord/hero.webp",
    color: "#08131b"
  },
  {
    slug: "sillage",
    title: "SILLAGE",
    type: "Нишевая парфюмерия",
    note: "E-commerce с редакционным ритмом",
    image: "/assets/sillage/hero.webp",
    color: "#5a0c19"
  },
  {
    slug: "field-os",
    title: "FIELD/OS",
    type: "Агротехнологии",
    note: "Интерактивная карта и ROI",
    image: "/assets/field/hero.webp",
    color: "#162016"
  },
  {
    slug: "govori",
    title: "ГОВОРИ",
    type: "Детская логопедия",
    note: "Сервис, доверие и доступная запись",
    image: "/assets/govori/hero.webp",
    color: "#f4a85f"
  },
  {
    slug: "null-field",
    title: "NULL//FIELD",
    type: "Музыкальный фестиваль",
    note: "Иммерсивная афиша и билетный сценарий",
    image: "/assets/nullfield/hero.webp",
    color: "#11100f"
  },
  {
    slug: "sloi-store",
    title: "SLOI",
    type: "Мультибрендовый магазин",
    note: "Витрина, личный кабинет и открытая CMS",
    image: "/assets/vanta/look-01.jpg",
    color: "#17181b"
  }
] as const;
